import { render, staticRenderFns } from "./WarnDialog.vue?vue&type=template&id=2fd69a24&scoped=true"
import script from "./WarnDialog.vue?vue&type=script&lang=ts"
export * from "./WarnDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd69a24",
  null
  
)

export default component.exports